import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=1e795b3c&scoped=true&"
import script from "./ForgetPassword.vue?vue&type=script&lang=js&"
export * from "./ForgetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ForgetPassword.vue?vue&type=style&index=1&id=1e795b3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e795b3c",
  null
  
)

export default component.exports